"use client";

import {
  WorkplaceRequestCategoriesParams,
  WorkplaceRequestCategoriesResponse
} from "@gettactic/api";
import { useInfiniteQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/api";

const DEFAULT_LIMIT = 100;

export function useWorkplaceRequestCategories(
  filters: WorkplaceRequestCategoriesParams = {},
  options: { enabled?: boolean } = {}
) {
  const {
    data,
    error,
    fetchNextPage,
    refetch,
    hasNextPage,
    isFetching,
    status
  } = useInfiniteQuery<WorkplaceRequestCategoriesResponse>({
    queryKey: ["workplaceRequestCategories", filters],
    queryFn: async ({ pageParam: cursor }) => {
      const queryFilters = { ...filters };
      if (cursor) {
        queryFilters.cursor = cursor as string;
      }
      const res =
        await api.client.workplaceRequestCategories.getWorkplaceRequestCategories(
          queryFilters
        );
      return res.result as WorkplaceRequestCategoriesResponse;
    },
    initialPageParam: undefined,
    enabled: options.enabled ?? true,
    getNextPageParam: (lastPage) => {
      if (!lastPage?.cursor) {
        return null;
      }
      if (lastPage.elements.length < (filters.limit ?? DEFAULT_LIMIT)) {
        return null;
      }
      return lastPage.cursor;
    }
  });

  const allElements = data?.pages.flatMap((page) => page?.elements ?? []) ?? [];

  return {
    data,
    error,
    fetchNextPage,
    refetch,
    hasNextPage,
    isFetching,
    status,
    allElements,
    totalElements: allElements.length
  };
}
